import React, { useState, useCallback, Suspense } from "react";
import { Container } from "reactstrap";

// ✅ Lazy load your components (only load when needed)
const CompactForm = React.lazy(() => import("./PaperTradingForm"));
const CompactFormEdit = React.lazy(() => import("./PaperTradingFormEdit"));
const ContractFormTableComponent = React.lazy(() => import("./table"));

function TablePaperTrading() {
  const [contractCreated, setContractCreated] = useState(0);
  const [copiedData, setCopiedData] = useState<any>(null);
  const [isEditMode, setEditMode] = useState<boolean>(false);
  const [editedData, setEditedData] = useState<any>(null);

  // ✅ useCallback makes stable references
  const handleSetCopiedData = useCallback((data: any) => setCopiedData(data), []);
  const handleSetEditMode = useCallback((mode: boolean) => setEditMode(mode), []);
  const handleSetEditedData = useCallback((data: any) => setEditedData(data), []);

  return (
    <Container fluid className="p-0" style={{ marginTop: 0 }}>
      <div className="table-ad" style={{ marginTop: 0 }}>
        {/* --- Form --- */}
        <Suspense fallback={<div>Loading form…</div>}>
          {isEditMode ? (
            <CompactFormEdit
              contractCreated={contractCreated}
              setContractCreated={setContractCreated}
              copiedData={copiedData}
              setEditMode={handleSetEditMode}
              isEditMode={isEditMode}
              editedData={editedData}
            />
          ) : (
            <CompactForm
              contractCreated={contractCreated}
              setContractCreated={setContractCreated}
              copiedData={copiedData}
            />
          )}
        </Suspense>

        {/* --- Table --- */}
        <Suspense fallback={<div>Loading table…</div>}>
          <ContractFormTableComponent
            contractCreated={contractCreated}
            setCopiedData={handleSetCopiedData}
            setEditMode={handleSetEditMode}
            setEditedData={handleSetEditedData}
          />
        </Suspense>
      </div>
    </Container>
  );
}

export default React.memo(TablePaperTrading);
